// @flow
import React from 'react'
import { Spring, config } from 'react-spring/renderprops.cjs'
import './styles.scss'
import { number } from 'prop-types'

type Props = {
  slideId: string,
  slideIndex: number,
  activeSlide: number,
  isMobile: boolean,
  imgMobile: string,
  imgDesktop: string,
  imgOverlay: string,
  animationplayed: boolean,
  isSliding: string
}

export class Slide02 extends React.Component<Props, State> {
  render() {
    let milliseconds =
      this.props.activeSlide === this.props.slideIndex ? 2500 : 0
    let screenWidth = window.innerWidth + 200
    let screenHeight = window.innerHeight
    let scaleFactor = 1
    let blur = 6
    return (
      <>
        <div
          className='section comic-slide'
          id={this.props.slideId}
          style={{
            backgroundImage: `url(${
              this.props.isMobile ? this.props.imgMobile : this.props.imgDesktop
            })`
          }}
        >
          <Spring
            from={{ yPos: 0, xPos: -screenWidth, scaleFactor: 1.5, blur: 6 }}
            to={{
              yPos:
                this.props.activeSlide === this.props.slideIndex
                  ? 0
                  : screenHeight / 10,
              xPos:
                this.props.activeSlide === this.props.slideIndex
                  ? 0
                  : -screenWidth,
              scaleFactor:
                this.props.activeSlide === this.props.slideIndex ? 1 : 1.5,
              blur: this.props.activeSlide === this.props.slideIndex ? 0 : 6
            }}
            config={{
              duration: milliseconds
            }}
            /* reset={{ xPos: this.props.activeSlide !== this.props.slideId }} */
          >
            {props => (
              <React.Fragment>
                <div
                  className='layer'
                  style={{
                    backgroundImage: `url(${
                      this.props.isMobile
                        ? this.props.imgOverlay
                        : this.props.imgOverlay
                    })`,
                    right: props.xPos,
                    bottom: props.yPos,
                    /* filter: 'blur(' + props.blur + 'px)', */
                    transform: 'scale(' + props.scaleFactor + ')',
                    height: '100%',
                    width: '100%',
                    backgroundSize: 'cover',
                    display: 'table',
                    tableLayout: 'fixed',
                    position: 'relative',
                    backgroundPosition: '50%'
                  }}
                />
              </React.Fragment>
            )}
          </Spring>
        </div>
      </>
    )
  }
}
